var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81 3.895C2.53 5.31 3.69 6.465 5.105 7.19L6.205 6.09C6.34 5.955 6.54 5.91 6.715 5.97C7.275 6.155 7.88 6.255 8.5 6.255C8.775 6.255 9 6.48 9 6.755V8.5C9 8.775 8.775 9 8.5 9C3.805 9 0 5.195 0 0.5C0 0.225 0.225 0 0.5 0H2.25C2.525 0 2.75 0.225 2.75 0.5C2.75 1.125 2.85 1.725 3.035 2.285C3.09 2.46 3.05 2.655 2.91 2.795L1.81 3.895Z",
    fill: "#FF0000",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneInfo);
export default __webpack_public_path__ + "static/media/phone-info.1f0692d36c4670323620c40becdd1124.svg";
export { ForwardRef as ReactComponent };